import { useState } from "react";

export default function Message() {

  /* ===============================
     SAMPLE DATA (REPLACE WITH API)
  =============================== */
  const conversations = [
    {
      id: 1,
      name: "TechStart Inc.",
      lastMessage: "Can we schedule a call?",
    },
    {
      id: 2,
      name: "Alpha Corp",
      lastMessage: "Please send the proposal.",
    },
    {
      id: 3,
      name: "Bright Solutions",
      lastMessage: "Thank you for the update!",
    },
  ];

  const [activeChat, setActiveChat] = useState(conversations[0]);
  const [messages, setMessages] = useState([
    { sender: "client", text: "Hello, I need help with marketing." },
    { sender: "admin", text: "Sure! We can assist you." },
  ]);
  const [input, setInput] = useState("");

  /* ===============================
     SEND MESSAGE
  =============================== */
  const sendMessage = () => {
    if (!input.trim()) return;

    setMessages([...messages, { sender: "admin", text: input }]);
    setInput("");
  };

  return (
    <div className="flex h-[calc(100vh-100px)] bg-white rounded-xl shadow-sm border overflow-hidden">

      {/* ===============================
         LEFT PANEL (INBOX)
      =============================== */}
      <div className="w-1/3 border-r overflow-y-auto">

        <div className="p-4 font-bold text-lg border-b">
          Messages
        </div>

        {conversations.map((chat) => (
          <div
            key={chat.id}
            onClick={() => setActiveChat(chat)}
            className={`p-4 cursor-pointer border-b hover:bg-gray-50 ${
              activeChat.id === chat.id ? "bg-gray-100" : ""
            }`}
          >
            <p className="font-semibold">{chat.name}</p>
            <p className="text-sm text-gray-500 truncate">
              {chat.lastMessage}
            </p>
          </div>
        ))}

      </div>

      {/* ===============================
         RIGHT PANEL (CHAT)
      =============================== */}
      <div className="flex-1 flex flex-col">

        {/* Header */}
        <div className="p-4 border-b font-semibold">
          {activeChat.name}
        </div>

        {/* Messages */}
        <div className="flex-1 p-4 space-y-3 overflow-y-auto bg-gray-50">

          {messages.map((msg, i) => (
            <div
              key={i}
              className={`flex ${
                msg.sender === "admin" ? "justify-end" : "justify-start"
              }`}
            >
              <div
                className={`px-4 py-2 rounded-lg max-w-xs text-sm ${
                  msg.sender === "admin"
                    ? "bg-green-600 text-white"
                    : "bg-white border"
                }`}
              >
                {msg.text}
              </div>
            </div>
          ))}

        </div>

        {/* Input */}
        <div className="p-4 border-t flex gap-2">
          <input
            type="text"
            placeholder="Type a message..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="flex-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          />

          <button
            onClick={sendMessage}
            className="bg-green-600 text-white px-4 rounded-lg hover:bg-green-700"
          >
            Send
          </button>
        </div>

      </div>

    </div>
  );
}